import { FormField, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';
import { Device } from '../../../common/Device';
import * as styles from './FormRow.css';

interface IProps {
  label: string;
  error?: string;
  className?: string;
  withoutMargin?: boolean;
  field: JSX.Element;
}

export const FormRow: React.FC<IProps> = ({ label, children, error, className, withoutMargin, field }) => {
  return (
    <Device
      mobile={
        <div className={classNames(styles['padded-container'], className)}>
          <FormField label={label} errorMessage={error} withoutMargin={withoutMargin}>
            {field}
          </FormField>
          {children}
        </div>
      }
      desktop={
        <div className={classNames(styles['form-row'], className)}>
          <div className={classNames(styles['label'], styles['padded-container'])}>
            <UIText2>{label}</UIText2>
          </div>
          <div>
            {field}
            {children}
          </div>
          {error && (
            <div className={styles['error-message-container']}>
              <div className={styles['arrow']} />
              <div className={styles['message']}>
                <UIText2 as="span" color="white_100">
                  {error}
                </UIText2>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};
